const { REACT_APP_CONTEXT_PATH } = process.env;

export const storeInfoApi = (storeId) => {
  return {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    apiUrl: REACT_APP_CONTEXT_PATH + `/branch/store-info/${storeId}`,
  };
};
